module.exports = ":host{display:flex;flex-direction:column}:host button{width:120px}:host button:not(:first-child){margin-top:10px}\n"